.container {
  margin-top: 8px;
  margin-bottom: 8px;
}

.title {
  margin-left: 32px;
}
